<template>
  <div>
    <div style="margin-top: -1.5rem">
      <div class="banner">
        <b-container>
          <b-row>
            <b-col cols="12" lg="5" class="banner__text pl-2">
              <h2 class="text-primary font-weight-bold banner__title">You’ve achieved so far</h2>
              <h2 class="text-primary font-weight-bold banner__title">Share your competency</h2>
              <h2 class="text-primary font-weight-bold banner__title">Share your pride</h2>
            </b-col>
            <b-col cols="12" lg="7">
              <b-img :src="require('../../assets/banner/banner-badge.png')" fluid />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <b-container class="mt-4">
      <div v-if="isLoading" class="d-flex justify-content-center">
        <b-spinner label="Loading..." variant="dark" />
      </div>

      <b-row v-else class="justify-content-center">
        <b-col cols="12">
          <div class="display-4 font-weight-bold mb-4">Badge collection</div>
          <ListCardBadgeCollection></ListCardBadgeCollection>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ListCardBadgeCollection from './components/ListCardBadgeCollection.vue';
export default {
  components: {
    ListCardBadgeCollection
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: auto;
  background: linear-gradient(90deg, #89f7fe 0%, #66a6ff 146.67%);

  &__text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: auto;
    margin-top: auto;

    @media only screen and (min-width: 370px) and (max-width: 992px) {
      align-items: center;
      margin-bottom: auto;
      margin-top: 1rem;
    }

    @media (max-width: 369px) {
      h2 {
        font-size: 1.45rem !important;
      }
      align-items: center;
      margin-bottom: auto;
      margin-top: 1rem;
    }
  }
}
</style>
